export const authHeaders = (language) => {
  try {
    const userToken = localStorage.getItem("token");

    if (!userToken || userToken === "null") return {};

    return {
      headers: {
        Authorization: `Bearer ${userToken}`,
        ...(language && { "Accept-Language": language }), // optional
      },
    };
  } catch (err) {
    console.error("Failed to generate auth headers:", err);
    return {};
  }
};
